module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "md-table md-theme-white"
  }, [_c('div', {
    staticClass: "md-content md-table-content"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', {
    staticClass: "table-body md-scrollbar"
  }, _vm._l((_vm.$props.value), function(printer) {
    return _c('tr', {
      key: printer.id,
      staticClass: "md-table-row"
    }, [_c('td', {
      staticClass: "md-table-cell"
    }, [_c('div', {
      staticClass: "md-table-cell-container"
    }, [_vm._v(" " + _vm._s(printer.id) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "md-table-cell"
    }, [_c('div', {
      staticClass: "md-table-cell-container"
    }, [_vm._v(" " + _vm._s(printer.name) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "md-table-cell"
    }, [_c('div', {
      staticClass: "md-table-cell-container"
    }, [_vm._v(" " + _vm._s(printer.ip) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "md-table-cell"
    }, [_c('div', {
      staticClass: "md-table-cell-container"
    }, [_vm._v(" " + _vm._s(printer.port) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "md-table-cell"
    }, [_c('div', {
      staticClass: "md-table-cell-container"
    }, [_vm._v(" " + _vm._s((printer.status ? printer.status.name : 'Не установлен')) + " ")])])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "md-table-head"
  }, [_c('div', {
    staticClass: "md-table-head-container md-ripple"
  }, [_c('div', {
    staticClass: "md-table-head-label "
  }, [_vm._v("ID")])])]), _vm._v(" "), _c('th', {
    staticClass: "md-table-head"
  }, [_c('div', {
    staticClass: "md-table-head-container md-ripple"
  }, [_c('div', {
    staticClass: "md-table-head-label "
  }, [_vm._v("Название")])])]), _vm._v(" "), _c('th', {
    staticClass: "md-table-head"
  }, [_c('div', {
    staticClass: "md-table-head-container md-ripple"
  }, [_c('div', {
    staticClass: "md-table-head-label "
  }, [_vm._v("ip")])])]), _vm._v(" "), _c('th', {
    staticClass: "md-table-head"
  }, [_c('div', {
    staticClass: "md-table-head-container md-ripple"
  }, [_c('div', {
    staticClass: "md-table-head-label"
  }, [_vm._v("Порт")])])]), _vm._v(" "), _c('th', {
    staticClass: "md-table-head"
  }, [_c('div', {
    staticClass: "md-table-head-container md-ripple"
  }, [_c('div', {
    staticClass: "md-table-head-label"
  }, [_vm._v("Статус")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d56221e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/components/StockPrinters.vue
// module id = 1158
// module chunks = 0